import routerOptions0 from "/tmpfs/builds/maltcommunity/malt/apps/malt/node_modules/.pnpm/nuxt@4.2.2_@parcel+watcher@2.4.1_@types+node@24.12.0_@vue+compiler-sfc@3.5.25_better-sq_5ad3366fcdf6847132fde8c4f8944271/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}